<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p class="img-centre"><img alt="" src="media/file0.png" style="width:2.01319in;height:2.96667in"/></p><br/>
<p style="text-indent:0em">Peter Cook is an engineer, educator, writer, inventor and problem solver, whose exploits have been well documented in the press.</p><br/>
<p style="text-indent:0em">Between 1996 and 2000, he co-founded and ran PJT Dynamics, an engineering company that specialised in finding solutions to well-known motorcycle flaws.</p><br/>
<p style="text-indent:0em">Whilst working on race engines, he started to tackle the problem of turbulence within systems.</p><br/>
<p style="text-indent:0em">Turbulence is one of the great unsolved problems in science, because by definition turbulence is unpredictable, and the laws of classical physics are by definition predictable. The question then is, how to reconcile turbulence with classical physics?</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?47ed5d2b